import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import {TableCounterIcon} from '../../../../../../global';
import { NgIf } from '@angular/common';
import { SvgIconComponent } from '../../../../svg-icon/svg-icon.component';
import { MatBadge } from '@angular/material/badge';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'slm-table-counter-icon',
    templateUrl: './table-counter-icon.component.html',
    styles: [
        `
           :host {
             display: block;
           }
         `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, SvgIconComponent, MatBadge, MatTooltip]
})
export class TableCounterIconComponent {
  @Input() data: TableCounterIcon = null;
  @Input() tooltip = '';
}
